module.exports = __webpack_public_path__ + "img/import-csv-example.b0c73abb.png";